import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { OrganizationModels, UserSettingsModels } from '@share-models';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  constructor(private readonly http: HttpClient) {}

  public getActiveOrganization(): Observable<OrganizationModels.OrganizationDocument> {
    return this.http.get<OrganizationModels.OrganizationDocument>(
      api.organization.crud,
    );
  }

  public updateSettings(organization: {
    orgId: string;
    orgName: string;
    lang: UserSettingsModels.LANGUAGE;
    startDayOfWeek: OrganizationModels.StartDayOfWeek;
  }): Observable<boolean> {
    return this.http.put<boolean>(
      `${api.organization.crud}/${organization.orgId}`,
      {
        orgName: organization.orgName,
        lang: organization.lang,
        startDayOfWeek: organization.startDayOfWeek,
      },
    );
  }

  public leave(userId: string, orgId: string): Observable<unknown> {
    return this.http.put(api.organization.leave(userId), {
      orgId,
    });
  }

  public delete(orgId: string): Observable<unknown> {
    return this.http.delete(api.organization.deleteAsync(orgId));
  }
}
